import { FC } from 'react'
import { Skeleton, Box, Grid, Text } from '@chakra-ui/react'

type Props = {
  isLoading?: boolean
  logs: string
  /**
   * @description Height in pixels
   */
  h?: number
}

const Console: FC<Props> = ({ isLoading, logs: rawLogs, h }) => {
  const logs = rawLogs.split('\n').map((line, i) => (
    <Grid
      gridTemplateColumns="32px 1fr"
      key={`${line[0]}-${i}`}
      px={4}
      _hover={{ bg: 'gray.600' }}
    >
      <Text
        as="code"
        color="whiteAlpha.500"
        fontSize="sm"
        mr={1}
        userSelect="none"
      >
        {i + 1}
      </Text>
      <Text as="code" color="white" fontSize="sm">
        {line}
      </Text>
    </Grid>
  ))
  return (
    <Skeleton isLoaded={!!rawLogs && !isLoading} rounded="md">
      <Box
        bgColor="gray.700"
        rounded="md"
        py={4}
        h={h ? `${h}px` : undefined}
        overflowY="auto"
      >
        {logs}
      </Box>
    </Skeleton>
  )
}

export default Console
